export default __webpack_public_path__ + "static/media/logo.fb747373.svg";